import { render, staticRenderFns } from "./CallsPerCampaign.vue?vue&type=template&id=d620fcfe&scoped=true&"
import script from "./CallsPerCampaign.vue?vue&type=script&lang=js&"
export * from "./CallsPerCampaign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d620fcfe",
  null
  
)

export default component.exports